export default __webpack_public_path__ + "static/media/47t.8ad392da.jpg";